import Personality from "components/personality/Personality";
import CourseAreas from "components/course-areas/CourseAreas";

import { ACTION_TYPE } from "reducers/actionType";
import AttributeCategory from "components/hoc/AttributeCategory";

// stored statically as CATEGORIES so prev/next can be derived
// [ ] Make attribute reference this file, instead of the other way round.
const CATEGORIES = [
  {
    name: "Interests",
    contributor: true,
    component: AttributeCategory({
      ATTRIBUTE_ACTIONS: ACTION_TYPE.INTEREST,
      title: "Interests",
      descriptiveTitle: "Popular Interests",
      prompt: "What are you interested in?",
      placeholder: "eg astronomy",
      nextCategory: "Skills",
    }),
    displayName: "My Interests",
    navlink: "interests",
    description: "I know what I'm interested in",
    inputSource: ["userInterests"],

    iconSource: {
      normal: "Icon-Interest.svg",
      active: "Icon-Interests-Side-Dark.svg",
      complete: "Icon-Interest-Completed.svg",
    },
    iconDimensions: {
      normal: {
        width: 40,
        height: 30,
      },
      complete: {
        width: 41,
        height: 34,
      },
    },
  },
  {
    name: "Skills",
    contributor: true,
    component: AttributeCategory({
      ATTRIBUTE_ACTIONS: ACTION_TYPE.SKILL,
      title: "Skills",
      descriptiveTitle: "Common Skills",
      prompt: "What are you good at?",
      placeholder: "eg sport",
      nextCategory: "Personality",
    }),
    displayName: "My Skills",
    navlink: "skills-set",
    description: "I know what I'm good at",
    inputSource: ["userSkills"],

    iconSource: {
      normal: "Icon-Skills.svg",
      complete: "Icon-Skills-Completed.svg",
      active: "Icon-Skills-Side-Dark.svg",
    },
    iconDimensions: {
      normal: {
        width: 32,
        height: 32,
      },
      complete: {
        width: 41,
        height: 37,
      },
    },
  },

  {
    name: "Personality",
    component: Personality,
    displayName: "My Personality",
    description: "I know the environment I'd like to work in",
    navlink: "personality",
    inputSource: ["userPersonality"],
    iconSource: {
      normal: "Icon-Personality.svg",
      complete: "Icon-Personality-Completed.svg",
      active: "Icon-Personality-Side-Dark.svg",
    },
    iconDimensions: {
      normal: {
        width: 26,
        height: 32,
      },
      complete: {
        width: 34,
        height: 35,
      },
    },
  },
  {
    name: "Career",
    contributor: true,
    displayName: "My Career",
    component: AttributeCategory({
      ATTRIBUTE_ACTIONS: ACTION_TYPE.CAREER,
      title: "Career",
      descriptiveTitle: "Popular Careers",
      prompt: "What careers are you interested in?",
      placeholder: "eg journalist",
      nextCategory: "CourseAreas",
    }),
    description: "I know my intended career path",
    navlink: "career",
    inputSource: ["userCareers"],

    iconSource: {
      normal: "Icon-Career.svg",
      complete: "Icon-Career-Completed.svg",
      active: "Icon-Career-Side-Dark.svg",
    },
    iconDimensions: {
      normal: {
        width: 33,
        height: 27,
      },
      complete: {
        width: 39,
        height: 32,
      },
    },
  },
  {
    name: "CourseAreas",
    contributor: true,
    displayName: "My Uni Course",
    component: CourseAreas,
    description: "I know what I want to study at uni",
    navlink: "course-areas",
    inputSource: ["userCourses"],

    iconSource: {
      normal: "Icon-Uni.svg",
      complete: "Icon-Uni-Completed.svg",
      active: "Icon-Uni-Side-Dark.svg",
    },
    iconDimensions: {
      normal: {
        width: 27,
        height: 38,
      },
      complete: {
        width: 38,
        height: 35,
      },
    },
  },
];
export default CATEGORIES;
